import { openAccordion } from '../utils/accordion';
import { $Q, $Qll } from '../utils/query-selector';
import { createInterception } from '../utils/script-defer';
import { initVideoFrame } from './video-frame';
import { initSeeMore } from '../utils/see-more';
import { isRegisteredUser } from './news-letters';
import { addTagScript } from '../utils/add-tag-script';

export const sectionsLoadDefer = () => {
  const accordions = $Q('.accordions');
  const videoModal = $Q('.video__button');
  const seeMore = $Q('.container__description');
  const newslatter = $Q('#contact_form')

  if (newslatter) createInterception(newslatter, () => isRegisteredUser());
  if (seeMore) createInterception(seeMore, () => initSeeMore());
  if (accordions) createInterception(accordions, () => openAccordion());
  if (videoModal) createInterception(videoModal, () => initVideoFrame());

  closeTopBar();
};

export const productCardVisible = () => {
  const productCards = $Qll('card-product');
  let loadScript = false;

  productCards.forEach((card) => {
    createInterception(card, async () => {
      if (loadScript) return;

      loadScript = true;
      await loadScriptProductCard();
    });
  })
}

export const loadScriptProductCard = async () => {
  const { dataset: { script } } = $Q('.product-card-script');
  return addTagScript(script, 'productCard');
}

const closeTopBar = () => {
  const close = $Q('#close-topbar-js');
  const bar = $Q('#topbar-js');
  const storage = sessionStorage.getItem('topbar');

  if (bar && !storage) {
    bar.setAttribute('data-active', 'true');
  }

  if (!bar || !close) return;

  close.addEventListener('click', () => {
    bar.setAttribute('data-active', 'false');
    sessionStorage.setItem('topbar', false);
  })
}
